import { ReactNode } from 'react';
import { usePreselectVariant } from '../../../hooks/usePreselectVariant';
import { DigitalWalletsSkeleton } from './digitalWalletsSkeleton.component';
import { DigitalWalletsWrapper } from './digitalWalletsWrapper.component';

export function DigitalWalletsSection({ children }: { children: ReactNode }) {
  const { isLoading, skipPreselect } = usePreselectVariant();

  if (isLoading) {
    return <DigitalWalletsSkeleton />;
  }

  return (
    <DigitalWalletsWrapper
      titleId={skipPreselect ? undefined : 'customerForm.payWithDigitalWallets'}
    >
      {children}
    </DigitalWalletsWrapper>
  );
}
